<template>
    <span>
        <component :is="buttonComponent" ref="helpicon" :class="buttonClasses" type="button">
            <b-spinner v-if="loading" small />
            <template v-else>
                <slot name="label">
                    {{ label }}
                </slot>
                <i :class="(iconMuted ? 'text-muted ' : '') + icon" />
            </template>
        </component>
        <b-popover :target="() => helpicon" :triggers="triggers" :placement="placement"
            :custom-class="'search-help ' + popoverCustomClass" :offset="popoverOffset" :delay="delay"
            :boundary="boundary" @show="$emit('show')" @hide="$emit('hide')">
            <slot :close="closePopover" />
            <VueShowdown v-if="markdown" :markdown="markdown" :options="markdownOptions" class="markdown" />
            <p v-if="text">{{ text }}</p>
        </b-popover>
    </span>

</template>

<script lang="ts">
import { Component, Vue, Ref, Prop } from "vue-property-decorator";

@Component({
    name: "HelpPopup",
})
export default class HelpPopup extends Vue {

    @Prop({ default: "click blur" }) protected triggers?: string;
    @Prop() protected text?: string;
    @Prop({ default: "bottomright" }) protected placement?: string;
    @Prop() protected label?: string;
    @Prop({ default: "fa fa-question-circle" }) protected icon?: string;
    @Prop({ default: true }) protected muted?: boolean;
    @Prop({ default: false }) protected iconMuted?: boolean;
    @Prop({ default: null }) protected variant?: string | null;
    @Prop({ default: "" }) protected popoverCustomClass?: string;
    @Prop({ default: null }) protected markdown?: string | null;
    @Prop({}) protected markdownOptions?: any;
    @Prop({ default: "" }) protected buttonCustomClass?: string;
    @Prop({ default: "button" }) protected buttonComponent!: string;
    @Prop({}) protected popoverOffset?: string | number;
    @Prop({ default: false }) protected loading!: boolean;
    @Prop({}) protected delay?: number | object;
    @Prop({}) protected boundary?: string;

    @Ref("helpicon") protected helpicon?: any;

    get buttonClasses() {
        const classes = [];

        if (this.buttonComponent === "button") classes.push("default");
        if (this.label || this.$slots.label) classes.push("hasLabel");
        if (this.muted) classes.push("text-muted");

        if (this.variant) {
            classes.push(`text-${this.variant}`);
        }

        if (this.buttonCustomClass) {
            classes.push(this.buttonCustomClass);
        }

        return classes;
    }

    closePopover() {
        this.$root.$emit('bv::hide::popover');
    }

}

</script>

<style scoped lang="scss">
button.default {
    border: 0;
    background: transparent;
    padding: 0 5px;

    &.hasLabel {
        background: rgb(248, 248, 248);
        border: 1px solid rgb(211, 211, 211);
        border-radius: 4px;

        &:hover {
            transition: all .2s;
            background: rgb(240, 240, 240);
            color: black !important;
        }
    }
}

.search-help {
    line-height: 1.25;

    ::v-deep(.popover-body > *:last-child),
    ::v-deep(.popover-body .markdown > *:last-child) {
        margin-bottom: 0;
    }

    ::v-deep(ul) {
        margin-bottom: 5px;
        padding-left: 20px;
    }
}
</style>